import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Wipe } from '@fiverr-private/transition';
import { SkeletonProps } from './types';

const Skeleton = ({
  children,
  animationDuration = 'moderate',
  animationDelay = 'moderate',
  width = 'fit-content',
  preferMotion = true,
  dataTestId,
  dataTrackTag = 'skeleton',
  dataTrackValue,
}: SkeletonProps) => (
  <Container
    width={width}
    overflow="hidden"
    position="relative"
    data-testid={dataTestId}
    dataTrackTag={dataTrackTag}
    dataTrackValue={dataTrackValue}
  >
    {preferMotion && <Wipe animationDuration={animationDuration} animationDelay={animationDelay} />}
    {children}
  </Container>
);

Skeleton.displayName = 'Skeleton';

export default Skeleton;
